<template>
  <section class="personal-center-panel">
    <h2>消息通知</h2>
    <p>未读 {{ front.unreadNotificationCount }} 条</p>
    <div v-if="front.myNotifications.length">
      <article v-for="item in front.myNotifications" :key="item.notificationId">
        <strong>{{ item.title }}</strong>
        <p>{{ item.content }}</p>
        <time>{{ item.createTime }}</time>
      </article>
    </div>
    <p v-else>暂无消息通知</p>
  </section>
</template>

<script>
export default {
  name: 'PersonalNotificationsPanel',
  inject: ['front']
}
</script>
